import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';
import {
  GET_ACTIVE_FILES_REQUEST,
  GET_ACTIVE_FILES_SUCCESS,
  GET_ACTIVE_FILES_FAILURE,
  GET_COVERING_FILES_REQUEST,
  GET_COVERING_FILES_SUCCESS,
  GET_COVERING_FILES_FAILURE,
  GET_CLOSED_FILES_REQUEST,
  GET_CLOSED_FILES_SUCCESS,
  GET_CLOSED_FILES_FAILURE,
  GET_CURRENT_COVERAGE_REQUEST,
  GET_CURRENT_COVERAGE_SUCCESS,
  GET_CURRENT_COVERAGE_FAILURE,
  ASSIGN_COVERAGE_REQUEST,
  ASSIGN_COVERAGE_SUCCESS,
  ASSIGN_COVERAGE_FAILURE,
  UPDATE_COVERAGE_REQUEST,
  UPDATE_COVERAGE_SUCCESS,
  UPDATE_COVERAGE_FAILURE,
  CANCEL_COVERAGE_REQUEST,
  CANCEL_COVERAGE_SUCCESS,
  CANCEL_COVERAGE_FAILURE,
  GET_INTERNAL_USERS_REQUEST,
  GET_INTERNAL_USERS_SUCCESS,
  GET_INTERNAL_USERS_FAILURE,
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  DISMISS_NOTIFICATION_REQUEST,
  DISMISS_NOTIFICATION_SUCCESS,
  DISMISS_NOTIFICATION_FAILURE,
  SET_COVERAGE_MODAL_OPEN,
  SET_COVERAGE_MODAL_CLOSED,
  SET_SELECTED_FILES,
  CLEAR_SELECTED_FILES,
} from './myFiles.types';

// Get active files for a user
export const getActiveFiles = (userId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_ACTIVE_FILES_REQUEST, GET_ACTIVE_FILES_SUCCESS, GET_ACTIVE_FILES_FAILURE],
    authenticated: true,
    endpoint: `api/my-files/active?userId=${userId}`,
    method: 'GET',
  }
});

// Get covering files for a user
export const getCoveringFiles = (userId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_COVERING_FILES_REQUEST, GET_COVERING_FILES_SUCCESS, GET_COVERING_FILES_FAILURE],
    authenticated: true,
    endpoint: `api/my-files/covering?userId=${userId}`,
    method: 'GET',
  }
});

// Get closed files for a user with pagination
export const getClosedFiles = (userId, pageNumber = 1, pageSize = 25) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_CLOSED_FILES_REQUEST, GET_CLOSED_FILES_SUCCESS, GET_CLOSED_FILES_FAILURE],
    authenticated: true,
    endpoint: `api/my-files/closed?userId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
    method: 'GET',
  }
});

// Get current coverage by user
export const getCurrentCoverage = (userId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_CURRENT_COVERAGE_REQUEST, GET_CURRENT_COVERAGE_SUCCESS, GET_CURRENT_COVERAGE_FAILURE],
    authenticated: true,
    endpoint: `api/my-files/coverage/current?userId=${userId}`,
    method: 'GET',
  }
});

// Assign coverage
export const assignCoverage = (coverageData) => ({
  [CALL_INTAKE_V2_API]: {
    types: [ASSIGN_COVERAGE_REQUEST, ASSIGN_COVERAGE_SUCCESS, ASSIGN_COVERAGE_FAILURE],
    authenticated: true,
    endpoint: 'api/my-files/coverage',
    method: 'POST',
    payload: coverageData,
  }
});

// Update coverage
export const updateCoverage = (coverageData) => ({
  [CALL_INTAKE_V2_API]: {
    types: [UPDATE_COVERAGE_REQUEST, UPDATE_COVERAGE_SUCCESS, UPDATE_COVERAGE_FAILURE],
    authenticated: true,
    endpoint: 'api/my-files/coverage',
    method: 'PUT',
    payload: coverageData,
  }
});

// Cancel coverage
export const cancelCoverage = (userId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [CANCEL_COVERAGE_REQUEST, CANCEL_COVERAGE_SUCCESS, CANCEL_COVERAGE_FAILURE],
    authenticated: true,
    endpoint: `api/my-files/coverage?userId=${userId}`,
    method: 'DELETE',
  }
});

// Get internal users (for coverage assignment dropdown)
export const getInternalUsers = () => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_INTERNAL_USERS_REQUEST, GET_INTERNAL_USERS_SUCCESS, GET_INTERNAL_USERS_FAILURE],
    authenticated: true,
    endpoint: 'api/my-files/users/internal',
    method: 'GET',
  }
});

// Get active notifications for user
export const getNotifications = (userId, type = null) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_NOTIFICATIONS_REQUEST, GET_NOTIFICATIONS_SUCCESS, GET_NOTIFICATIONS_FAILURE],
    authenticated: true,
    endpoint: `api/notifications/active?userId=${userId}${type ? `&type=${type}` : ''}`,
    method: 'GET',
  }
});

// Dismiss notification
export const dismissNotification = (notificationId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [DISMISS_NOTIFICATION_REQUEST, DISMISS_NOTIFICATION_SUCCESS, DISMISS_NOTIFICATION_FAILURE],
    authenticated: true,
    endpoint: `api/notifications/${notificationId}/dismiss`,
    method: 'POST',
  }
});

// UI Actions
export const setCoverageModalOpen = (isEditing = false, existingCoverage = null) => ({
  type: SET_COVERAGE_MODAL_OPEN,
  payload: { isEditing, existingCoverage },
});

export const setCoverageModalClosed = () => ({
  type: SET_COVERAGE_MODAL_CLOSED,
});

export const setSelectedFiles = (files) => ({
  type: SET_SELECTED_FILES,
  payload: files,
});

export const clearSelectedFiles = () => ({
  type: CLEAR_SELECTED_FILES,
});
